// PRE-2379 — schema promotion: PERMANENT locks the schema against deletion (423).
export const PROMOTE_SCHEMA_REQUEST = "PROMOTE_SCHEMA_REQUEST";
export const PROMOTE_SCHEMA_SUCCESS = "PROMOTE_SCHEMA_SUCCESS";
export const PROMOTE_SCHEMA_FAILURE = "PROMOTE_SCHEMA_FAILURE";

export const DEMOTE_SCHEMA_REQUEST = "DEMOTE_SCHEMA_REQUEST";
export const DEMOTE_SCHEMA_SUCCESS = "DEMOTE_SCHEMA_SUCCESS";
export const DEMOTE_SCHEMA_FAILURE = "DEMOTE_SCHEMA_FAILURE";

export const promoteSchemaRequest = (businessAreaId, schemaId) => ({ type: PROMOTE_SCHEMA_REQUEST, params: { businessAreaId, schemaId } });
export const promoteSchemaSuccess = (schemaModel) => ({ type: PROMOTE_SCHEMA_SUCCESS, payload: schemaModel });
export const promoteSchemaFailure = (error) => ({ type: PROMOTE_SCHEMA_FAILURE, payload: error });

export const demoteSchemaRequest = (businessAreaId, schemaId) => ({ type: DEMOTE_SCHEMA_REQUEST, params: { businessAreaId, schemaId } });
export const demoteSchemaSuccess = (schemaModel) => ({ type: DEMOTE_SCHEMA_SUCCESS, payload: schemaModel });
export const demoteSchemaFailure = (error) => ({ type: DEMOTE_SCHEMA_FAILURE, payload: error });
